module.exports = __webpack_public_path__ + "img/gebackenegarnelenmithintergrund.9c41d3e4.jpg";